import UnitService from '@src/api/services/UnitService';
// import { CountryInterface } from '@src/api/interfaces/Unit';

import cookie from 'react-cookies';
import CountryModel from '@src/api/models/CountryModel';
import LanguageModel from '@src/api/models/LanguageModel';
import RootState from '@src/interfaces/RootState';
import { change } from 'redux-form';
import { put, select } from 'redux-saga/effects';
import { SET_ERROR_OBJECT } from '../error/actions';
import { SET_LOADING } from '../ui/actions';
import { Dayjs } from 'dayjs';

/** Saga Actions */
export const GET_COUNTRY_LIST = 'GET_COUNTRY_LIST';
export const GET_BANK_LIST = 'GET_BANK_LIST';
export const GET_BANK_COUNTRY_LIST = 'GET_BANK_COUNTRY_LIST';
export const GET_LANGUAGE_LIST = 'GET_LANGUAGE_LIST';
export const GET_PARTNER_LIST = 'GET_PARTNER_LIST';
export const GET_SHOP_LIST = 'GET_SHOP_LIST';
export const GET_EMPLOYEE_LIST = 'GET_EMPLOYEE_LIST';
export const GET_PRODUCT_GROUP_LIST = 'GET_PRODUCT_GROUP_LIST';
export const GET_PRODUCT_BRAND_LIST = 'GET_PRODUCT_BRAND_LIST';
export const GET_WARRANTY_LIST = 'GET_WARRANTY_LIST';
export const GET_WARRANTY_PRICE_LIST = 'GET_WARRANTY_PRICE_LIST';
export const GET_SHOP_DETAILS = 'GET_SHOP_DETAILS';

/** Reducer Actions */
export const SET_CLAIM_TYPE_LIST = 'SET_CLAIM_TYPE_LIST';
export const SET_COUNTRY_LIST = 'SET_COUNTRY_LIST';
export const SET_BANK_LIST = 'SET_BANK_LIST';
export const SET_BANK_COUNTRY_LIST = 'SET_BANK_COUNTRY_LIST';
export const SET_LANGUAGE_LIST = 'SET_LANGUAGE_LIST';
export const SET_PARTNER_LIST = 'SET_PARTNER_LIST';
export const SET_SHOP_LIST = 'SET_SHOP_LIST';
export const SET_EMPLOYEE_LIST = 'SET_EMPLOYEE_LIST';
export const SET_PRODUCT_GROUP_LIST = 'SET_PRODUCT_GROUP_LIST';
export const SET_PRODUCT_BRAND_LIST = 'SET_PRODUCT_BRAND_LIST';
export const SET_WARRANTY_LIST = 'SET_WARRANTY_LIST';
export const RESET = 'RESET';

export function* getShopDetails() {
    yield put({ type: SET_LOADING, val: true });
    try {
        const partner = yield select((state: RootState) => state?.form?.partnerForm?.values);

        const payload = {
            partnerId: partner?.partner,
            shopId: partner?.shop,
        };
        const response = yield UnitService.shopDetails(payload);
        if (response?.status == 200) {
            yield put(change('partnerForm', 'partnerEmail', response?.data?.email));
        } else {
            yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: response?.status } });
        }
    } catch (error) {
        console.log('file: actions.ts:56 ~ function*shopDetails ~ error:', error);
        yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: 500 } });
    } finally {
        yield put({ type: SET_LOADING, val: false });
    }
}
/**
 * Warranty Price List
 */
// export function* getWarrantyPriceList() {
//     yield put({ type: SET_LOADING, val: true });
//     const partnerForm = yield select((state: RootState) => state?.form?.partnerForm?.values);
//     const selectedWarranty = yield select((state: RootState) => state?.form?.productForm?.values?.warranty);
//     const warrantyList = yield select((state: RootState) => state?.unit?.warrantyList);
//     const payload = {
//         prt_id: partnerForm?.partner,
//         // prt_id: 'as',
//         pricecode: warrantyList?.find((item) => item?.value == selectedWarranty)?.pricecode,
//         start_date: partnerForm?.deliveryDate,
//         end_date: partnerForm?.deliveryDate,
//     };
//     try {
//         const response = yield UnitService.warrantyPriceList(payload);
//         yield put(change('productForm', 'warrantyPrice', response?.data[0]?.warrantyprice));
//         yield put(change('productForm', 'warrantySellingPrice', response?.data[0]?.warrantyprice));
//     } catch (error) {
//         yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: error?.response?.status } });
//     }

//     yield put({ type: SET_LOADING, val: false });
// }
/**
 * Warranty List
 */
export function* getWarrantyList() {
    const attributes = yield select((state: RootState) => state?.contract?.attributes);
    const productGroupList = yield select((state: RootState) => state?.unit?.productGroupList);
    const productBrandList = yield select((state: RootState) => state?.unit?.productBrandList);
    yield put({ type: SET_LOADING, val: true });
    yield put({ type: SET_WARRANTY_LIST });
    const partnerForm = yield select((state: RootState) => state?.form?.partnerForm?.values);

    const productForm = yield select((state: RootState) => state?.form?.productForm?.values);
    const payload = {
        partnerId: partnerForm?.partner,
        brandId: productForm?.brand,
        groupId: productForm?.group,
        warrantySalesDate: (partnerForm?.deliveryDate as Dayjs).format('YYYY-MM-DD'),
        articleType: productForm?.model,
        articlePrice: productForm?.price,
        receiptNumber: '-',
    };
    const dynamicAttributes: any[] = [];
    if (attributes.filter((data) => data?.name === 'PRODUCT_GROUP').length > 0) {
        dynamicAttributes.push({
            attributeInventoryId: attributes.filter((data) => data?.name === 'PRODUCT_GROUP')[0]?.id,
            attributeValue: productGroupList.filter((data) => data?.value == productForm?.group)[0]?.label,
        });
    }
    if (attributes.filter((data) => data?.name === 'ARTICLE_PRICE').length > 0) {
        dynamicAttributes.push({
            attributeInventoryId: attributes.filter((data) => data?.name === 'ARTICLE_PRICE')[0]?.id,
            attributeValue: productForm?.price,
        });
    }
    if (attributes.filter((data) => data?.name === 'BRAND').length > 0) {
        dynamicAttributes.push({
            attributeInventoryId: attributes.filter((data) => data?.name === 'BRAND')[0]?.id,
            attributeValue: productBrandList.filter((data) => data?.value == productForm?.brand)[0]?.label,
        });
    }
    if (dynamicAttributes.length > 0) {
        payload['dynamicAttributes'] = dynamicAttributes;
    }

    try {
        const response = yield UnitService.warrantyList(payload);

        if (response.status == 200) {
            const warranties = response?.data;

            warranties.forEach((warranty) => {
                warranty.value = warranty?.warrantyId;
                warranty.label = warranty?.name;
                warranty.name = warranty?.name;
            });
            yield put({ type: SET_WARRANTY_LIST, val: warranties });
        } else {
            yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: response?.status } });
        }
    } catch (error) {
        yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: 500 } });
    } finally {
        yield put({ type: SET_LOADING, val: false });
    }
}

/**
 * Product Group List
 */
export function* getProductGroupList() {
    yield put({ type: SET_LOADING, val: true });
    const schema = cookie.load('SCH_ID');
    const isProductGroupListStored = yield select((state: RootState) => state?.unit?.productGroupList);
    /** Check if already stored any employee list
     * if stored then return, DO NOT send api request for it
     */
    if (isProductGroupListStored != null) {
        yield put({ type: SET_LOADING, val: false });
        return;
    }

    const partnerId = yield select((state: RootState) => state?.form?.partnerForm?.values?.partner);

    const queryParams = {
        partnerId: partnerId,
    };
    const response = yield UnitService.productGroupList(queryParams);

    if (response.status == 200) {
        const resultArray: Array<any> = [];

        // Append the required keys
        for (const data of response?.data) {
            resultArray.push({
                value: data.id,
                label: data.name,
                name: data.name,
                info: data,
            });
        }
        if (schema === 'N_INDEP_MOBILE') {
            // Filter to only GSM and Smartphone
            const filteretToGsmSmartphone = resultArray.filter((item) => item.value !== '4' && item.value !== '7');

            // Sort by date decrement
            const sortedArr = filteretToGsmSmartphone.sort((a, b) => new Date(b?.info?.startDate.replace('T00:00:00', '')).getTime() - new Date(a?.info?.startDate.replace('T00:00:00', '')).getTime());
            yield put({ type: SET_PRODUCT_GROUP_LIST, val: sortedArr });
        } else {
            yield put({ type: SET_PRODUCT_GROUP_LIST, val: resultArray });
        }
    } else {
        yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: response?.status } });
    }
    yield put({ type: SET_LOADING, val: false });
}
/**
 * Product Brand List
 */
export function* getProductBrandList() {
    yield put({ type: SET_LOADING, val: true });

    const isProductBrandListStored = yield select((state: RootState) => state?.unit?.productBrandList);
    /** Check if already stored any product brand list
     * if stored then return, DO NOT send api request for it
     */
    if (isProductBrandListStored != null) {
        yield put({ type: SET_LOADING, val: false });
        return;
    }

    const partnerId = yield select((state: RootState) => state?.form?.partnerForm?.values?.partner);
    const payload = {
        partnerId: partnerId,
    };
    const response = yield UnitService.productBrandList(payload);

    if (response.status == 200) {
        const resultArray: Array<any> = [];
        // Append value, label and name to fit for select field
        // Append the required keys
        for (const data of response?.data) {
            resultArray.push({
                value: data.id,
                label: data.name,
                name: data.name,
                info: data,
            });
        }
        yield put({ type: SET_PRODUCT_BRAND_LIST, val: resultArray });
    } else {
        yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: response?.status } });
    }
    yield put({ type: SET_LOADING, val: false });
}
/**
 * Employee List
 */
export function* getEmployeeList() {
    yield put({ type: SET_LOADING, val: true });

    // const isEmployeeListStored = yield select((state: RootState) => state?.unit?.employeeList);
    // console.log('file: actions.ts:240 ~ function*getEmployeeList ~ isEmployeeListStored:', isEmployeeListStored);

    /** Check if already stored any employee list
     * if stored then return, DO NOT send api request for it
     */
    // if (isEmployeeListStored != null) {
    //     yield put({ type: SET_LOADING, val: false });
    //     return;
    // }

    const partnerId = yield select((state: RootState) => state?.form?.partnerForm?.values?.partner);
    const shopId = yield select((state: RootState) => state?.form?.partnerForm?.values?.shop);
    const payload = {
        shopId: shopId,
        partnerId: partnerId,
    };

    try {
        const response = yield UnitService.employeeList(payload);

        if (response.status == 200) {
            response.data?.forEach((item) => {
                item.value = item.id;
                item.label = item.name;
                item.name = item.name;
            });
            yield put({ type: SET_EMPLOYEE_LIST, val: response.data });
        } else {
            yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: response?.status } });
        }
    } catch (error) {
        yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: 500 } });
    }
    yield put({ type: SET_LOADING, val: false });
}
/**
 * Shop List
 */
export function* getShopList() {
    yield put({ type: SET_LOADING, val: true });
    // const isShopListStored = yield select((state: RootState) => state?.unit?.shopList);
    /** Check if already stored any shop list
     * if stored then return, DO NOT send api request for it
     */
    // if (isShopListStored != null) {
    //     yield put({ type: SET_LOADING, val: false });
    //     return;
    // }

    const partnerId = yield select((state: RootState) => state?.form?.partnerForm?.values?.partner);

    const payload = {
        partnerId: partnerId,
    };

    const response = yield UnitService.shopList(payload);
    if (response.status == 200) {
        response.data?.forEach((item) => {
            item.value = item.id;
            item.label = item.name;
            item.name = item.name;
        });
        yield put({ type: SET_SHOP_LIST, val: response.data });
    } else {
        yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: response?.status } });
    }
    yield put({ type: SET_LOADING, val: false });
}
/**
 * Partner List
 */
export function* getPartnerList() {
    yield put({ type: SET_LOADING, val: true });
    yield put({ type: SET_SHOP_LIST, val: null });
    yield put({ type: SET_EMPLOYEE_LIST, val: null });
    // yield put(change('partnerForm', 'shop', null));
    const isPartnerListStored = yield select((state: RootState) => state?.unit?.partnerList);
    /** Check if already stored any partner list
     * if stored then return, DO NOT send api request for it
     */
    if (isPartnerListStored != null) {
        yield put({ type: SET_LOADING, val: false });
        return;
    }
    /**
     * Get request for Claim types
     */
    // const username = sessionStorage.getItem('username');
    const response = yield UnitService.partnerList();

    if (response.status == 200) {
        const pattern = /[A-Z][A-Z]\d{3}/i;
        const newFilter = response.data?.filter((item) => item.partnerId.match(pattern));

        newFilter.forEach((item) => {
            (item.value = item?.partnerId), (item.label = item?.partnerName), (item.name = item?.partnerName);
        });

        newFilter.sort((a, b) => a.name.localeCompare(b.name));

        yield put({ type: SET_PARTNER_LIST, val: newFilter });
    } else {
        yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: response?.status } });
    }
    yield put({ type: SET_LOADING, val: false });
    return true;
}

/**
 * Country list
 */
export function* getCountryList() {
    yield put({ type: SET_LOADING, val: true });
    const isCountriesStored = yield select((state: RootState) => state?.unit?.countryList);
    /** Check if already stored any country list
     * if stored then return, DO NOT send api request for it
     */
    if (isCountriesStored != null) {
        yield put({ type: SET_LOADING, val: false });
        return;
    }

    const response = yield UnitService.countryList();

    if (response.status == 200) {
        const countryList: any = [];
        response.data?.supportedCountries.forEach((item) => {
            const countryItem = new CountryModel(item);
            countryList.push(countryItem);
        });
        yield put({ type: SET_COUNTRY_LIST, val: countryList });
    } else {
        yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: response?.status } });
    }
    yield put({ type: SET_LOADING, val: false });
}

/**
 * Langauge list
 */
export function* getLanguageList() {
    yield put({ type: SET_LOADING, val: true });
    const isLanguagesStored = yield select((state: RootState) => state?.unit?.languageList);
    /** Check if already stored any language list
     * if stored then return, DO NOT send api request for it
     */
    if (isLanguagesStored != null) {
        yield put({ type: SET_LOADING, val: false });
        return;
    }

    const response = yield UnitService.languageList();

    if (response.status == 200) {
        const languageList: any = [];
        response.data.supportedLanguages.forEach((item) => {
            const countryItem = new LanguageModel(item);
            languageList.push(countryItem);
        });
        yield put({ type: SET_LANGUAGE_LIST, val: languageList });
    } else {
        yield put({ type: SET_ERROR_OBJECT, val: { dictionaryObject: 'common_errors', errorCode: response?.status } });
    }
    yield put({ type: SET_LOADING, val: false });
}
